module.exports = __webpack_public_path__ + "img/cooler.a0797f00.svg";